export const CHAT_MODEL = {
  "chat-normal": {
    name: "3.5 综合模型",
  },
  "chat-plus": {
    name: "GPT4.0 文字模型",
  },
  GPT4o: {
    name: "GPT4o 超强模型",
  },
  "deep-seek": {
    name: "GPT3.5 推理模型",
  },
  "deep-seek-v3": {
    name: "DeepSeek V3 文字模型",
  },
  "GPT4.0": {
    name: "GPT4.0 写作模型",
  },
  GPTo1: {
    name: "GPTo1 推理模型",
  },
  GPTo3: {
    name: "GPTo3 推理模型",
  },
  R1: {
    name: "DeepSeek R1 推理模型",
  },
};
